export let constants = {
	projectTitle: 'IV Demo',
	mainContent508Id: '508-main-content',
	debugMode: false,
	debugQuestions: false,
	uiTags: {
		Hud: 'Hud'
	},
	toolbagTools: {
		tourniquet: {
			img: './assets/images/Toolbag/tourniquet.png',
			text: 'Tourniquet'
		},
		antisepticWipes: {
			img: './assets/images/Toolbag/antiseptic_wipes.png',
			text: 'Antiseptic Wipes'
		},
		needleGaugeOrIvCannula: {
			img: './assets/images/Toolbag/needle_gauge_iv_cannula.png',
			text: 'Needle Gauge/IV Cannula'
		},
		tapeOrTegaderm: {
			img: './assets/images/Toolbag/tape_tegaderm.png',
			text: 'Tape/Tegaderm'
		},
		extensionTubing: {
			img: './assets/images/Toolbag/extension_tubing.png',
			text: 'Extension Tubing'
		},
		salineFlush: {
			img: './assets/images/Toolbag/saline_flush.png',
			text: 'Saline Flush'
		}
	},
	design: {
		hoverColor1: 'rgb(83, 103, 149)',
		hoverColor2: 'rgb(159, 191, 211)' //submit button
	},
	uiNames: {
		HUDUI: 'HUDUI',
		ReturnToMainMenuUI: 'ReturnToMainMenuUI',
		QuestionType1UI: 'QuestionType1UI',
		FeedbackUI: 'FeedbackUI',
		AlertUI: 'AlertUI',
		SkipContentUI: 'SkipContentUI',
		AiChatUI: 'AiChatUI',
		IntroScreenUI: 'IntroScreenUI',
		ScenarioInfoUI: 'ScenarioInfoUI',
		OverlayImgUI: 'OverlayImgUI',
		AarUI: 'AarUI',
	},
};